var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDebitCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_debit-credit",
    "data-name": "icon/debit-credit",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(16 16)",
    fill: "#1b2b4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_payment_24px",
    "data-name": "icon/payment_24px",
    transform: "translate(22.297 22.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 20,
    height: 20,
    transform: "translate(-0.297 -0.297)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "card-r",
    transform: "translate(1.596 3.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M10.414,13.75H6v1.324h4.414Z",
    transform: "translate(-2.948 -5.804)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M2.25,4.75H18.465v12.8H2.25ZM3.5,6.074v3.09H17.218V6.074Zm0,10.153V10.488H17.218v5.738Z",
    transform: "translate(-2.25 -4.75)",
    fill: "#3bb0ff",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDebitCredit);
export default __webpack_public_path__ + "static/media/icon-debit-credit.54f8f14f663ffe903dd61935431aef4f.svg";
export { ForwardRef as ReactComponent };